import React from 'react';
import COLOR from '@Src/commons/Colors';
import {
  Banner,
  NormalText,
  PageTitle,
  StyledSpace,
} from '@Src/commons/StyledComponent';

type Props = {
  title: string;
  subTitle?: string;
  description?: string;
};

export default function PageBanner({ title, subTitle, description }: Props) {
  return (
    <Banner customPadding="12px 16px" customBackground="#F3F8FF">
      <StyledSpace direction="vertical" size={6}>
        <PageTitle color={COLOR.GRAY_10} fontSize={20} fontWeight={600}>
          {title}
        </PageTitle>
        {(subTitle || description) && (
          <StyledSpace size={2} direction="vertical">
            {subTitle && (
              <NormalText color={COLOR.GRAY_10}>{subTitle}</NormalText>
            )}
            {/* {description && (
              <NormalText color={COLOR.GRAY_8} fontSize={12}>
                {description}
              </NormalText>
            )} */}
          </StyledSpace>
        )}
      </StyledSpace>
    </Banner>
  );
}
PageBanner.defaultProps = {
  subTitle: '',
  description: '',
};
